import styled from 'styled-components';
import { media } from '../../../../../theme/shared/breakpoints';
import { Link } from '../../../../components/Link/Link';
import { Gray } from '../../../../constants/styles';
export const TopbarWrapper = styled.div `
  background-color: ${({ backgroundColor }) => backgroundColor || Gray.x300};
  border-bottom: 1px solid ${Gray.x200};
  padding: 1px 0;
  width: 100%;
  min-height: 21px;
  max-height: 41px;
`;
export const TopbarContent = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;

  ${media.medium} {
    align-items: center;
    justify-content: space-between;
    text-align: left;
  }
`;
export const StyledLink = styled(Link) `
  display: inline-block;
  color: ${({ theme }) => theme.colorsV2.font.textLink};
  font-size: ${({ theme }) => theme.fontSizes.sizeSm3};
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
export const TopbarSeparator = styled.span `
  display: inline-block;
  margin: 0 4px;
`;
//# sourceMappingURL=Topbar.styled.js.map